@if ((isRedirectPage$ | async) === false) {
    <router-outlet></router-outlet>
}

<app-checkout-wc-wrapper></app-checkout-wc-wrapper>